import React from "react";
import MovieCard from "./MovieCard";
import movieList from "./MovieList";
import { Link } from "react-router-dom";

let reviewedMovies = movieList.slice(-10);

let items = reviewedMovies.map((movie) => {
  return (
    <MovieCard
      key={movie.id}
      name={movie.name}
      poster={movie.poster}
      rating={movie.rating}
      year={movie.year}
      synopsis={movie.synopsis}
      genre={movie.genre}
      subgenre={movie.subgenre}
      runtime={movie.runtime}
      pairs={movie.pairs}
      noPairs={movie.noPairs}
      drinkRecipe={movie.drinkRecipe}
      rated={movie.rated}
      picture1={movie.picture1}
      picture2={movie.picture2}
      picture3={movie.picture3}
      tagline={movie.tagline}
      taglineWriter={movie.taglineWriter}
      bulletOne={movie.bulletOne}
      bulletTwo={movie.bulletTwo}
      bulletThree={movie.bulletThree}
      cast={movie.cast}
    />
  );
});

function NewReviewHomePage() {
  return (
    <div>
      <div className="employeePickContainer">
        <div className="genresignHomepage">
          <p className="homepageLatestReviews">LATEST REVIEWS</p>
          <p className="newReviewDateHomepage">
            Last updated October 7th, 2026.
          </p>
          <div className="seeAllContainer">
            <Link
              to="/ratings"
              style={{ color: "blue" }}
              className="seeAllReviewsLink"
            >
              See all reviews
            </Link>
          </div>
        </div>
      </div>

      <div className="renderContainerHomepage">{items}</div>
    </div>
  );
}

export default NewReviewHomePage;
